<template>
  <k-editor-form>
    <template #left>
    <Loading :visible="saveLoading" :error="true">
      <div slot="infoContent">
        <div v-if="saveLoading" style="background-color: var(--ks-col-info); color: var(--ks-font-color); padding: 15px; border-radius: 4px; margin-bottom: 10px;">
          <div style="text-align: center; margin-bottom: 12px;">
            <k-progress-circular indeterminate style="vertical-align: middle; margin-right: 8px;"></k-progress-circular>
            <b style="vertical-align: middle;">Uploading {{files.length}} files...</b>
          </div>
          <div style="text-align: center;">Do not close or refresh this window until all files are uploaded.</div>
        </div>
      </div>
    </Loading>
    <div style="height: 532px; overflow: auto; padding: 10px;" v-if="list_type && contents">
      <k-layout>
        <k-flex c12 style="padding-right: 4px;">

        </k-flex>
        <k-flex c12 style="padding-right: 4px; margin-bottom: 8px;">
          <k-panel style="padding: 8px; border-radius: 2px;">
            <k-autocomplete label="File Field" :items="fileFields" item-text="title" item-value="name" v-model="fileField"></k-autocomplete>
            <k-autocomplete label="Name field" :items="nameFields" item-text="title" item-value="name" v-model="nameField" clearable></k-autocomplete>
            <div style="display: flex;">
              <div style="flex-grow: 1;"></div>
              <k-btn @click="onPickFiles">
                Select files...
              </k-btn>
            </div>
            <input type="file" ref="fileInput" style="display: none" multiple accept="*/*" @change="onFilesPicked"/>
            <k-divider class="mt-1 mb-1" />
            <div style="max-height: 160px; overflow-y: auto;">
              <k-layout>
                <k-flex c4 v-for="file in files" :key="file.name">
                  <k-chip size="s" close @click:close="removeFile(file)"><span class="text-truncate">{{file.name}}</span></k-chip>
                </k-flex>
              </k-layout>
            </div>
          </k-panel>
        </k-flex>
        <k-flex c4 style="padding-right: 4px; margin-bottom: 8px;">
          <k-btn @click="create_data()">Convert</k-btn>
        </k-flex>
        <k-flex c12 style="padding-right: 4px;">
          <table>
            <tbody>
              <tr v-for="(line, index) in converted" :key="index">
                <td v-for="(row, rindex) in line" :key="rindex">
                  {{row}}
                </td>
              </tr>
            </tbody>
          </table>

        </k-flex>

      </k-layout>

      <k-panel v-for="(editor, index) in editors" :key="index" style="margin-top: 10px;" class="elevation-1">
        <editor :data="id" ref="editors" :initial="editor" :noheight="true" :hideactions="true"></editor>
      </k-panel>


    </div>
    </template>
    <template #right-buttons>
      <k-btn color="success" @click="save(true)" :disabled="saveLoading" :loading="saveLoading">Save and close</k-btn>
    </template>
  </k-editor-form>
</template>

<script>
import * as FormItems from '@/components/form_items'
import ContentModel from '@/models/content.js'
import { v4 as uuidv4 } from 'uuid';
import Vue from 'vue'
import Papa from 'papaparse';
import Editor from './Editor';
import Loading from "@/components/Loading"

export default {
  props: ['id', 'data_id'],

  data () {
    return {
      channel: undefined,
      list_data: {},
      is_headers: false,
      row_delimiter: "\t",
      data: [],
      converted: [],
      editors: [],
      files: [],
      fileField: "",
      nameField: "",
      saveLoading: false
    }
  },
  components: {
    Editor,
    Loading
  },
  computed: {
    headers () {
      var ret = [{ text: 'Id', value: 'id', align: 'left' }];
      _.each(this.fields, (field) => {
        ret.push({ text: field.title, value: 'data.' + field.name, align: 'left', sortable: true});
      });
      ret.push({ text: 'Actions', value: 'actions', align: 'right', sortable: false});
      return ret;
    },
    contents () {
      return Object.values(this.list_data);
    },

    content_list () {
      return _.find(this.content_lists, (cl) => {
        return cl.id == this.id;
      });
    },
    fields () {
      var lt = this.list_type;
      return lt.fields["fields"]
    },
    nameFields() {
      return _.filter(this.fields, (field) => {
        return field.type == "text"
      });
    },
    fileFields() {
      return _.filter(this.fields, (field) => {
        return field.type == "file" || field.type == "s3file"
      });
    },
    list_type () {
      var cl = this.content_list;
      return _.find(this.list_types, (lt) => {
        return lt.id == cl.cms_list_type_id;
      });
    },
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    list_types () {
      return Object.values(this.$store.state.cms_list_types);
    },
  
  },
  mounted() {
    this.connect_ws();
  },
  beforeDestroy: function() {
    this.channel.leave();
  },
  methods: {
    create_data () {
      if(_.isEmpty(this.fileField)) return;
      this.editors = _.map(this.files, (file) => {
        var retdata = {};

        retdata[this.fileField] = file;
        if(!_.isEmpty(this.nameField)) {
          retdata[this.nameField] = file.name.split('.').slice(0, -1).join('.');
        }

        return retdata;
      });

    },
    onPickFiles() {
      this.$refs.fileInput.click();
    },
    onFilesPicked(event) {
      const files = event.target.files
      this.files = files
    },
    removeFile(file) {
      this.files = _.filter(this.files, (f) => { return f.name != file.name });
    },

    reset() {

    },
    save (close) {
      this.saveLoading = true;
      var promises = _.map(this.$refs.editors, (editor) => {
        return new Promise((resolve, reject) => { editor.save(false, true, resolve, reject) });
      });
      Promise.allSettled(promises).then((results) => {
        if(_.countBy(results, (r) => { return r.status })["fulfilled"] == promises.length) {
          this.$message.success("Files uploaded!");
          this.saveLoading = false;
          if (close) {
            this.$root.close_bottom_sheet();
          }

        } else {
          this.saveLoading = false;
          this.$message.success("Unable to upload files!");
        }
      });

    },
    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
    connect_ws () {
      var self = this;
      this.channel = this.$socket.channel("cms:list_datas:"+this.id);
      this.channel.on("init", function(msg) {
        msg.list_data.forEach(function(d) {
          Vue.set(self.list_data, d.id, d);
        });
      });
      this.channel.on("update", function(msg) {
        Vue.set(self.list_data, msg.list_data.id, msg.list_data);
      });
      this.channel.on("delete", function(msg) {
        Vue.delete(self.list_data, msg.list_data.id);
      });
      this.channel.join();
    }
  }
}
</script>
